<template>
<v-dialog
v-model="visible"
max-width="600px"
hide-overlay
>

	<v-layout row>
		<v-flex xs12>
		<v-card>
			<v-img v-if="imageUrl"
			:src="imageUrl"
			contain
			height="200px"
			></v-img>
			
			<v-card-title primary-title>
			<div>
				<div class="headline">{{token.metadata.name || token.token_id}}</div>
				<small class="grey--text">{{token.metadata.name && token.token_id}}</small>
			</div>
			</v-card-title>
			
			<v-card-text>
			{{token.metadata.description}}
			</v-card-text>
			
			<v-divider></v-divider>
			
			<v-card-text>
				<v-layout row>
					<v-flex xs6 sm4>
						<v-text-field
						label="Created"
						:value="token.created |tstamp"
						readonly
						></v-text-field>
						
						<v-text-field
						label="Expires"
						:value="token.expiry || 'Never' |tstamp"
						readonly
						></v-text-field>
					</v-flex>
					<v-spacer></v-spacer>
					<v-flex xs5 sm4>
						<v-text-field v-if="token.shared_by"
						label="Shared by"
						:value="token.shared_by"
						readonly
						></v-text-field>
						
						<v-chip v-if="permissions.includes('c') && permissions.includes('r')"
						color="primary"
						text-color="white">
							Read-write
						</v-chip>
						<v-chip v-else-if="permissions.includes('r')"
						color="success"
						text-color="white">
							Read-only
						</v-chip>
						<v-chip v-else-if="permissions.includes('c')"
						color="warning"
						>
							Write-only
						</v-chip>
					</v-flex>
				</v-layout>
				<v-layout row>
					<v-flex xs12>
						Record with:<br/>
						<v-menu :close-on-content-click="false" v-model="menu.osmand">
							<v-btn small slot="activator">OsmAnd</v-btn>
							<v-card>
								<v-card-text>
									<v-text-field ref="osmand"
									label="Tracker URL"
									hint="Copy this URL by clicking on the icon"
									persistent-hint
									append-icon="fa-copy"
									:append-icon-cb="copyText('osmand')"
									:value="url.osmand"
									read-only
									/>
								</v-card-text>
							</v-card>
						</v-menu>
						<v-menu :close-on-content-click="false" v-model="menu.traccar">
							<v-btn small slot="activator">Traccar</v-btn>
							<v-card>
								<v-card-text>
									<v-text-field ref="traccar"
									label="Tracker URL"
									hint="Copy this URL by clicking on the icon"
									persistent-hint
									append-icon="fa-copy"
									:append-icon-cb="copyText('traccar')"
									:value="url.traccar"
									read-only
									/>
								</v-card-text>
							</v-card>
						</v-menu>
					</v-flex>
				</v-layout>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat color="primary" @click="visible = false">Close</v-btn>
			</v-card-actions>
			
		</v-card>
		</v-flex>
	</v-layout>

</v-dialog>
</template>

<style lang="stylus" scoped>
>>>
	textarea
		font-size 9pt
		font-family mono
	#script
		color blue
		font-style bold
</style>

<script>
import Vuex from 'vuex'
import * as moment from 'moment'
import api from '../../assets/js/api-instance'


export default {
	name: "FollowTokenInfo",
	
	props: [ "show" ],
	
	data () {
		return {
			menu: {
				osmand: false,
				traccar: false
			}
		}
	},
	
	computed: {
		visible: {
			get () {
				return !!this.show;
			},
			set (value) {
				if (!value) {
					this.$emit('hide')
				}
			},
		},
		
		token () {
			return this.$store.state.tokenData.tokens.find(t => t.token_id == this.show) ||
				{ metadata: {} };
		},
		
		imageUrl () {
			return this.token.metadata && this.token.metadata.imageUrl;
		},
		
		permissions () {
			return this.token.permissions || ""
		},
		
		url () {
			const osmand = `${api.url}/token/${this.token.token_id}/save?lat={0}&lon={1}&timestamp={2}&accuracy_h={3}&altitude={4}&speed={5}&bearing={6}&id=${this.token.created}`;
			const traccar = `${api.url}/api/v0/token/${this.token.token_id}/save/speed:knots;tstamp:seconds`;
			return {
				osmand,
				traccar
			}
		}
	},
	
	filters: {
		tstamp (val, fmt = "YYYY-MM-DD HH:mm:ss") {
			const m = moment(val);
			return m.isValid()
				? m.format(fmt)
				: val;
		}
	},
	
	methods: {
		copyText(el) {
			return () => {
				const element = this.$refs[el].$el.querySelector("input");
				element.focus();
				element.select();
				document.execCommand('copy');
				this.$root.$emit('snackbar', {message: "URL copied to clipboard"});
				this.menu[el] = false;
			}
		},
		
		async dismiss () {
			this.$emit("hide");
		}
	}

}
</script>
